import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { DailyEffortsModuleName } from '@/store/modules/modules'

export class DailyEffortsViewModel {
  private store = useStore()

  chartData: ComputedRef<{ labelChartData: number[]; dailyEffortsChartData: number[][]; maxEffort: number }> = computed(
    () => this.store.getters[`${DailyEffortsModuleName}/chartData`]
  )
  chartSeries: ComputedRef<any[]> = computed(() => this.store.getters[`${DailyEffortsModuleName}/chartSeries`])
  chartOptions: ComputedRef<any> = computed(() => this.store.getters[`${DailyEffortsModuleName}/chartOptions`])
  hasData: ComputedRef<boolean> = computed(() => this.store.getters[`${DailyEffortsModuleName}/hasData`])

  setChartData(chartData: { labelChartData: number[]; dailyEffortsChartData: number[][]; maxEffort: number }): void {
    this.store.commit(`${DailyEffortsModuleName}/setChartData`, chartData)
  }

  setChartSeries(chartSeries: any[]): void {
    this.store.commit(`${DailyEffortsModuleName}/setChartSeries`, chartSeries)
  }

  setChartOptions(chartOptions: any): void {
    this.store.commit(`${DailyEffortsModuleName}/setChartOptions`, chartOptions)
  }

  setHasData(hasData: boolean): void {
    this.store.commit(`${DailyEffortsModuleName}/setHasData`, hasData)
  }
}
